module.exports = __webpack_public_path__ + "static/media/saleemQureshi.69144120.jpg";